import styled from "styled-components";

export const ForgetPasswordStep2Styled = styled.div`
  margin: auto;
  width: 100%;
  .register_header {
    margin-bottom: 30px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .register_title {
    margin-bottom: 30px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .register_email {
    margin-bottom: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .otp_code {
    margin-bottom: 40px;
  }

  .register_button {
    margin-bottom: 20px;
  }
  .back {
    display: flex;
    justify-content: center;
    align-items: baseline;
    column-gap: 6px;
    .back_text {
      color: ${({ theme }) => theme.COLORS.GRAY_14};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    .back_button {
      border-bottom: 0.5px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      padding: 0;
      background: none;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      cursor: pointer;
    }
  }
`;
